<template>
    <div class="u-full-width">
        <p>Verteilung nach Jahr</p>
        <CanvasJSChart :options="options" :styles="styleOptions"/>
    </div>
</template>

<script>
import CanvasJSChart from './CanvasJSVueComponent.vue'

export default {
    components: {
        CanvasJSChart,
    },

    props: {
        /**
         * { label: '2023', y: 15 }
         */
        dataPoints: { type: Array, required: true },
    },

    data: () => ({
        styleOptions: {
            width: '100%',
            height: '360px',
        },
    }),

    computed: {
        dataPointsWithCombineOlderYears () {
            const yearsInPast = 3
            const currentYear = (new Date()).getFullYear()

            const newerYears = this.dataPoints.filter(({ label }) => {
                return parseInt(label, 10) >= (currentYear - yearsInPast)
            })
            const olderYears = this.dataPoints.filter(({ label }) => {
                return parseInt(label, 10) < (currentYear - yearsInPast)
            })
            const olderYearsSum = olderYears.map(x => x.y).reduce((total, num) => total + num, 0)

            return newerYears.concat({ label: `vor ${currentYear - yearsInPast}`, y: olderYearsSum })
        },

        options () {
            return {
                theme: 'light',
                animationEnabled: true,
                data: [{
                    type: 'pie',
                    indexLabel: '{label} (#percent%)',
                    yValueFormatString: '#,##0',
                    toolTipContent: '<span style=\'"\'color: {color};\'"\'>{label}</span> {y}(#percent%)',
                    dataPoints: this.dataPointsWithCombineOlderYears,
                }],
            }
        },
    },
}
</script>
